
import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from "@angular/material/sort";

import { MatStepper } from '@angular/material/stepper';
import { MatPaginator } from '@angular/material/paginator';
import swal from 'sweetalert2';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from '@angular/router';

import { AuthenticationService } from 'src/app/authentication.service';
import { UserlogService } from '../../service/userlog.service';
import { LogService } from '../../../portal/service/log.service';
import { MainService } from '../../service/main.service';
import { SettingService } from '../../service/setting.service';
import { session } from '../../../../environments/environment.session';
import Swal from 'sweetalert2';
declare var $: any
@Component({
  selector: 'app-code-value',
  templateUrl: './code-value.component.html',
  styleUrls: ['./code-value.component.css']
})
export class CodeValueComponent {
  constructor(private userlog: UserlogService, private log: LogService, public auth: AuthenticationService, public mainService: MainService, private settingService: SettingService, private router: Router, private spinner: NgxSpinnerService) { }
  erpUser: any;
  b_acct_id: any;
  logObj: any = { component: 'ROLE' }

  allFields: any = [];
  obj: any = {};
  selectField: any;
  allCodeValue: any = [];
  selectedCodeValue: any = []
  codeValueObj: any = {};
  codeValueShowObj: any = {};

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();

  displayedColumns: any = ['id', 'code', 'value', 'action'];
  datasource: any;

  async ngOnInit() {
    this.erpUser = JSON.parse(atob(session.erpUser)); this.b_acct_id = this.erpUser.b_acct_id;
    console.log(this.auth.allLableShowObjProp)
    await this.getAllFields();
    await this.getCodeValue();

  }
  list_flag = true
  create_flag = false
  update_flag = false
  open_create() {

    this.list_flag = false
    this.create_flag = true
    this.update_flag = false
  }
  async open_list() {
    this.list_flag = true
    this.create_flag = false
    this.update_flag = false
    await this.getAllFields();
    await this.getCodeValue();
    //await this.getAllHeirarchy()
    //await this.getpropertygroup()
    //await this.getAllOffers()
  }


  async getCodeValue() {
    this.spinner.show();

    var resp = await this.settingService.getCodeValue(this.b_acct_id);
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "All Code Value Received Successfully " })
      this.allCodeValue = resp.data;
      this.changeField();

      this.spinner.hide();

    } else {
      this.spinner.hide()
      swal.fire("Oops", "...Error while getting all values!", 'error');

    }
  }
  open_update(element: any) {
    this.obj = Object.assign({}, element);
    this.selectField = element.field_code;
    $('.nav-tabs a[href="#tab-3"]').tab('show')
    this.list_flag = false
    this.create_flag = false
    this.update_flag = true
  }

  refresh() {
    this.obj = {};
  }


  async changeField() {
    this.selectedCodeValue = [];
    for (var i = 0; i < this.allCodeValue.length; i++) {
      if (this.selectField == this.allCodeValue[i].field_code) {
        this.selectedCodeValue.push(this.allCodeValue[i])
      }
    }
    this.datasource = new MatTableDataSource(this.selectedCodeValue)
    this.datasource.paginator = this.paginator.toArray()[0];
    this.datasource.sort = this.sort.toArray()[0];
  }

  async getAllFields() {
    var obj: any = new Object();
    obj['domain_code'] = 'NOC';
    obj['b_acct_id'] = this.b_acct_id;
    this.spinner.show();

    var resp = await this.settingService.getFields(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "All Fields Received Successfully " })
      this.allFields = resp.data;
      this.spinner.hide();

    } else {
      this.spinner.hide()
      swal.fire("Oops", "...Error while getting all fields!", 'error');

    }
  }
  message: any
  async save() {
    this.spinner.show();
    if (this.obj['code'] == undefined || this.obj['code'] == null || this.obj['code'] == '' ||
      this.obj['value'] == undefined || this.obj['value'] == null || this.obj['value'] == ''
    ) {
      this.spinner.hide()
      swal.fire('Info', "All fields marked with * are Mandatory.", 'info')
      return
    }
    this.obj['create_user_id'] = this.erpUser.user_id;
    this.obj['field_code'] = this.selectField;
    this.obj['b_acct_id'] = this.b_acct_id;
    var resp = await this.settingService.insertCodeValue(this.obj);
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'POST', message: "Code Value Submitted Successfully " })
      this.spinner.hide();
      this.open_list()
      await this.getCodeValue();
      await this.getCodeValueForService();
      await this.getCodeValue_obj()
      this.message = "code value saved " + this.obj['field_code']
      let resp = await this.userlog.insertLoginInfo(this.message);
      console.log(resp);
      swal.fire("Success", "...code value added!", 'success');
    }
    else if (resp["error"] == "check") {
      this.spinner.hide();

      Swal.fire("Error", resp.data, 'error')
    } else {
      this.spinner.hide();
      swal.fire("Oops", "...Error while adding code value!", 'error');

    }
  }
  async getCodeValue_obj() {
    this.spinner.show()
    var resp = await this.settingService.getCodeValue(this.b_acct_id);
    var codeValueTempObj: any = {}
    var codeValueShowTempObj: any = {};
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "Code Value Received Successfully " })
      this.spinner.hide()
      for (var i = 0; i < resp.data.length; i++) {
        if (codeValueTempObj[resp.data[i]['field_code']] == undefined) {
          codeValueTempObj[resp.data[i]['field_code']] = [];
          codeValueShowTempObj[resp.data[i]['field_code']] = {}
        }
        codeValueShowTempObj[resp.data[i]['field_code']][resp.data[i].code] = resp.data[i].value;
        codeValueTempObj[resp.data[i]['field_code']].push(resp.data[i])
      }
      this.codeValueObj = codeValueTempObj;
      this.codeValueShowObj = codeValueShowTempObj;
      this.mainService.codeValueTechObj = this.codeValueObj;
      this.mainService.codeValueShowObj = this.codeValueShowObj;
    } else {
      this.spinner.hide()
    }
  }

  async update() {
    if (!this.obj['value']) {
      swal.fire('info', 'Please Enter Field Value', 'info');
      return
    }
    this.spinner.show();
    this.obj['update_user_id'] = this.erpUser.user_id;
    this.obj['field_code'] = this.selectField;
    this.obj['b_acct_id'] = this.b_acct_id;
    var resp = await this.settingService.updateCodeValues(this.obj);
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'PUT', message: "Code Value Updated Successfully " })
      this.spinner.hide();
      this.open_list()
      await this.getCodeValue();
      await this.getCodeValueForService();
      await this.getCodeValue_obj()
      this.message = "udated field code of " + this.obj['field_code']
      let resp = await this.userlog.insertLoginInfo(this.message);
      console.log(resp);
      swal.fire("Success", "...code value updated!", 'success');

    } else {
      this.spinner.hide();
      swal.fire("Oops", "...Error while updating code value!", 'error');

    }
  }
  async getCodeValueForService() {
    this.spinner.show();

    var resp = await this.settingService.getCodeValue(this.b_acct_id);
    var codeValueTempObj: any = {}
    var codeValueShowTempObj: any = {};
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "All Code Value Received for Service Successfully " })
      for (var i = 0; i < resp.data.length; i++) {
        if (codeValueTempObj[resp.data[i]['field_code']] == undefined) {
          codeValueTempObj[resp.data[i]['field_code']] = [];
          codeValueShowTempObj[resp.data[i]['field_code']] = {}
        }
        codeValueShowTempObj[resp.data[i]['field_code']][resp.data[i].code] = resp.data[i].value;
        codeValueTempObj[resp.data[i]['field_code']].push(resp.data[i])
      }
      this.codeValueObj = codeValueTempObj;
      this.codeValueShowObj = codeValueShowTempObj;
      this.mainService.codeValueTechObj = this.codeValueObj;
      this.mainService.codeValueShowObj = this.codeValueShowObj;
      this.spinner.hide();

    } else {
      this.spinner.hide();

    }

  }
  async delete(element: any) {

    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Delete it!'
    }).then(async (result) => {
      if (result.value) {
        var obj: any = new Object();
        obj['b_acct_id'] = this.b_acct_id;
        obj['id'] = element.id;

        this.spinner.show();
        var resp = await this.settingService.deleteCodeValue(JSON.stringify(obj));

        if (resp['error'] == false) {
          this.log.createLog({ ...this.logObj, activity: 'DELETE', message: "Code Value Deleted Successfully " })
          await this.getCodeValue();
          await this.getCodeValueForService();
          this.message = "deleted code value of " + obj['id']
          let resp = await this.userlog.insertLoginInfo(this.message);
          console.log(resp);
          this.spinner.hide();
          swal.fire("Success", "...code value Deleted!", 'success');
        } else {
          this.spinner.hide();
          swal.fire("Oops", "...code value not deleted!", 'error');
        }
      }
    })


  }


  applyFilter(filterValue: string) {
    this.datasource.filter = filterValue.trim().toLowerCase();
  }
}
